import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { default as swal } from 'sweetalert2';

import { BaseService, AuthHttpService } from '../';


export class ClientService extends BaseService {

	private baseUrl: string = '/v2/client/guest/client';

	constructor(private authHttp: AuthHttpService) {
		super();
	}

	public get(): Observable<any> {
		let url: string = this.baseUrl;
		return this.authHttp.get(url)
			.map(this.extractResponseData)
			.catch((err) => this.handleError(err, '?qp_alert=c_p_guest_error'));
	}

	public postBillingSign(data: any): Observable<any> {
		let url: string = this.baseUrl + '/billing/signature';
		return this.authHttp.post(url, JSON.stringify(data))
			.map(this.extractResponseData)
			.catch(
				(error) => {
					error.message = this.extractResponseData(error);

					return Observable.throw(error);
				}
			);
	}

	public createClientToken(data: any): Observable<any> {
		let url = this.baseUrl + '/password_token';
		return this.authHttp.post(url, JSON.stringify(data))
			.map(this.extractResponseData)
			.catch((error) => {
				return this.handleError(error);
			});
	}

	public getBillingLatest(): Observable<any> {
		let url: string = this.baseUrl + '/billing/latest';
		return this.authHttp.get(url)
			.map(this.extractResponseData)
			.catch((error: any) => {
				if (error.status === 404) {
					return Observable.throw(error);
				}
				return this.handleError(error);
			});
	}

	public validateEmail(data: any): Observable<any> {
		let url: string = this.baseUrl + '/email/domain/validation';
		return this.authHttp.post(url, JSON.stringify(data))
			.map(this.extractResponseData)
			.catch((err) => this.handleError(err, '?qp_alert=c_p_invalid_email_guest_error'));
	}
}(ClientService as any).ctorParameters = function () { return [ { type: AuthHttpService } ]; }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/services/client/client.service.ts